import { authGet, authPost } from '../auth/authFetches';
import { Proposal } from '../interfaces/types';
import { safeFetch } from '../utils/safeFetch';

export async function fetchProposalList(accessToken: string) {
  const path = `/proposalsData/listProposals`;
  return await authGet(accessToken, path);
}

export async function fetchProposal(accessToken: string, id: string) {
  const path = `/proposalsData/fetchProposal`;
  return await authPost(accessToken, path, { id });
}

export async function saveProposal(accessToken: string, proposal: Proposal) {
  const path = `/proposalsData/saveProposal`;
  return await authPost(accessToken, path, proposal);
}

export async function deleteProposal(accessToken: string, id: string) {
  const path = `/proposalsData/deleteProposal`;
  console.log('Deleting proposal with id:', id);
  return await authPost(accessToken, path, { id });
}

export async function generateWordDoc(
  accessToken: string,
  body: any,
  setDocumentLoading: (loading: boolean) => void,
  signal: AbortSignal
) {
  setDocumentLoading(true);

  const path = '/proposalsData/generateWordDoc';
  console.log('Generating Word Doc');
  const domain = import.meta.env.VITE_API_URL || '';
  const uri = domain + path;
  try {
    const response = await safeFetch(uri, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(body),
      signal: signal,
    });

    const blob = await response.blob();
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = 'proposal.docx'; // Default filename

    console.log('Content disposition:', contentDisposition);
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+?)"/);
      if (match && match[1]) {
        filename = match[1];
        console.log('Extracted filename:', filename);
      } else {
        console.log('No filename found in Content-Disposition');
      }
    } else {
      console.log('No Content-Disposition header found');
    }

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    setDocumentLoading(false);
  } catch (err: any) {
    if (err.name === 'AbortError') {
      console.log('Fetch aborted');
      setDocumentLoading(false);
      return;
    }
    setDocumentLoading(false);
    console.error(
      `POST request to uri ${uri} with body:\n${JSON.stringify(body, undefined, 4)} failed`
    );
    console.error(err);
    throw err; // Re-throw the error so it propagates to the caller
  }
}

export async function generateExperiencesOffer(accessToken: string, query: string) {
  const path = '/proposalsData/generateExperiencesOffer';
  console.log('Generating Experiences for Offer');
  return await authPost(accessToken, path, { query });
}

export async function generateLawyersOffer(accessToken: string, query: string) {
  const path = '/proposalsData/generateLawyersOffer';
  console.log('Generating Lawyers for Offer');
  return await authPost(accessToken, path, { query });
}

export async function getLawyerList(accessToken: string) {
  const path = '/proposalsData/getLawyerList';
  return await authGet(accessToken, path);
}

export async function fetchExpertise(accessToken: string) {
  const path = `/proposalsData/getExpertise`;
  return await authGet(accessToken, path);
}

export async function getLawyersPositions(accessToken: string, lawyerNames: string[]) {
  const path = '/proposalsData/fetchLawyersPositions';
  return await authPost(accessToken, path, { lawyerNames: lawyerNames });
}

export const batchDownloadProposals = async (accessToken: string): Promise<void> => {
  const response = await authGet(accessToken, '/proposalsData/batch-download');
  const a = document.createElement('a');
  a.href = response.url;
  a.download = 'all-proposals.zip';
  document.body.appendChild(a);
  a.click();
  a.remove();
};
